export var createSyncBlockNode = function createSyncBlockNode(localId, resourceId) {
  return {
    type: 'syncBlock',
    attrs: {
      localId: localId,
      resourceId: resourceId
    }
  };
};